import { useEffect, useState } from 'react';

// Returns a debounced copy of `value` that only updates after `delay` ms of no
// changes. Useful to throttle search inputs before hitting the API.
export function useDebouncedValue<T>(value: T, delay = 250): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
